module.exports = __webpack_public_path__ + "54d06881ea161efbae3bf14c74864b8f.svg";